// Client.js
// Redux Container for Client View

// Imports
import { connect } from 'react-redux';
import * as Action from '../actions/product';
import ProductView from '../components/ProductView/';

// State Mapper
const mapStateToProps = state => ({
  products: state.product,
});

// Action Mapper
const mapDispatchToProps = dispatch => ({
  addProduct: (name) => dispatch(Action.addProduct(name)),
  renameProduct: (id, name) => dispatch(Action.renameProduct(id, name)),
  removeProduct: (id) => dispatch(Action.removeProduct(id)),
  addUnit: (pId, name) => dispatch(Action.addUnit(pId, name)),
  removeUnit: (pId, uId) => dispatch(Action.removeUnit(pId, uId)),
  renameUnit: (pId, uId, name) => dispatch(Action.renameUnit(pId, uId, name)),
  setUnitPrice: (pId, uId, price) => dispatch(Action.setUnitPrice(pId, uId, price)),
})

// Exports
export default connect(mapStateToProps, mapDispatchToProps)(ProductView);


// WEBPACK FOOTER //
// ./src/containers/Product.js